import { render, staticRenderFns } from "./PanelTitle.vue?vue&type=template&id=2472f721&scoped=true"
import script from "./PanelTitle.vue?vue&type=script&lang=js"
export * from "./PanelTitle.vue?vue&type=script&lang=js"
import style0 from "./PanelTitle.vue?vue&type=style&index=0&id=2472f721&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2472f721",
  null
  
)

export default component.exports